"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    background = _ref.background,
    palette = _ref.palette;
  return {
    root: function root(props) {
      return {
        '& .currencyAdornment': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          '& > span': {
            marginRight: '6px',
            fontSize: '14px',
            letterSpacing: '-0.7px',
            lineHeight: '19px'
          }
        },
        '& input': {
          width: props.currencyInput && '213px'
        },
        '& .MuiInputBase-input': {
          fontSize: '1rem',
          padding: '0.375rem 0.75rem',
          height: '2.84rem',
          boxSizing: 'border-box'
        },
        '& .MuiFormHelperText-root': {
          position: 'absolute',
          bottom: -18,
          marginLeft: 0
        },
        '& .MuiInputLabel-root': {
          fontSize: '1rem'
        },
        '& > .MuiOutlinedInput-root': {
          lineHeight: 1.5,
          height: '2.84rem',
          fontWeight: typography.fontWeightLight,
          backgroundColor: background.primary
        },
        '& > .MuiFilledInput-root': {
          fontSize: '14px',
          lineHeight: 1.5,
          fontWeight: typography.fontWeightLight,
          backgroundColor: '#F7F7F7',
          borderRadius: '5px',
          height: 50,
          '&:hover, &.Mui-focused': {
            backgroundColor: '#F7F7F7'
          },
          '&:after, &:before': {
            content: 'none'
          },
          '& .MuiInputBase-input': {
            fontSize: '14px',
            height: '50px',
            lineHeight: 1.35,
            color: props.detailsModal ? '#CF752F' : palette.secondary.main,
            fontWeight: typography.fontWeightRegular
          },
          '& svg': {
            fontSize: '16px'
          }
        },
        '& > .MuiInputLabel-outlined': {
          transform: 'translate(14px, 14px) scale(1)'
        },
        '& > .MuiInputLabel-outlined.MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.75)'
        },
        '& > .MuiTooltip-tooltip': {
          wordBreak: 'break-word'
        }
      };
    },
    currencyLabel: {
      display: 'inline-block',
      margin: '0 0 16px 0',
      textTransform: 'capitalize',
      fontSize: '14px',
      lineHeight: '19px'
    },
    warningIcon: {
      color: '#DEC500'
    }
  };
}, {
  name: 'Input'
});
exports.useStyles = useStyles;